module.exports = __webpack_public_path__ + "static/media/ni.87480e3d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ni.svg
// module id = 946
// module chunks = 0